<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-medium" type="error" dismissible>
      {{ error.response && error.response.status === 429 ? "We're sorry, but you have sent too many requests to us recently. Please try again later." : error.message }}
    </v-alert>
      <!-- <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12  v-if="hasSession && hasLicenseAdminRole">
        <v-list two-line class="br-10 elevation-3 indigo lighten-4 blue-grey--text text--darken-3" color="blue" @click.native="$router.push('/trading/list')">
          <v-list-item>
            <v-list-item-action>
              <img width="50" height="50" src="img/cards/checked.png">
            </v-list-item-action>
            <v-list-item-content class="pl-2">
              <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">Senarai Permohonan Lesen Berniaga (Office Use Only)</v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12 >
        <v-list two-line class="br-10 elevation-3 pink lighten-4 blue-grey--text text--darken-3" color="blue">
        <v-list two-line class="br-10 elevation-3 pink lighten-4 blue-grey--text text--darken-3" color="blue" @click.native="$router.push('/trading/form')">
          <v-list-item>
            <v-list-item-action>
              <img width="50" height="50" src="img/cards/checked.png">
              <img width="65" src="img/cards/new.png">
              <img width="65" src="img/cards/coming-soon.png">
            </v-list-item-action>
            <v-list-item-content class="pl-2">
              <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('license_application_trading') }}</v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout> -->
    <!-- <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 lighten-4 black--text" color="blue">
            <v-list two-line class="br-10 elevation-0 lighten-4 black--text" color="blue" @click.native="menu2 = !menu2">
              <v-list-item>
                <v-list-item-action>
                  <img width="50" height="50" src="img/cards/checked.png">
                  <img width="65" src="img/cards/new.png">
                  <img width="65" src="img/cards/coming-soon.png">
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header3', { type: $t('page_license.trading') }) }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu2" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu2" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu2" @submit.prevent="searchTradingApplication()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <v-text-field :value="form.id" @input="setForm({ form: { id: $event} })" :label="$t('reference_no')"/>
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="!form.id" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout> -->


    <!-- License Query  -->
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 blue lighten-4 black--text" color="blue" @click.native="menu1 = !menu1">
              <v-list-item>
                <v-list-item-action>
                  <div style="max-height: 50px">
                    <img width="50" height="50" src="img/cards/checked.png">
                  </div>
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header5') }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu1" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu1" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu1" @submit.prevent="searchData()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <v-text-field :value="data.searchId" @input="patchData({ searchId: $event })" :label="$t('page_license.index.hint2')"/>
                <span class="caption"><strong>{{ $t('page_license.index.hintTrading') }}</strong></span><br>
                <!-- <v-text-field :value="data.ic_no" @input="patchData({ ic_no: $event })" :label="`${$t('ic_no')} / No ${$t('passport')} / ${$t('old_ic')}`"/> -->
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="checkEmptyObject(data) || !data.searchId" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                  <!-- <v-btn :disabled="data === {} || !data.searchId || !data.ic_no" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn> -->
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout>
    <!-- Application Query  -->
    <!-- <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 lighten-4 black--text" color="blue" @click.native="menu2 = !menu2" style="cursor: pointer;">
              <v-list-item>
                <v-list-item-action>
                  <img width="50" height="50" src="img/cards/checked.png">
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header3', { type: $t('page_license.trading') }) }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu1" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu1" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu2" @submit.prevent="searchTradingApplication()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <v-text-field :value="form.id" @input="setForm({ form: { id: $event} })" :label="$t('reference_no')"/>
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="!form.id" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout> -->
    <!-- Result Trading Application  -->
    <v-layout justify-center v-if="Object.keys(resultData).length > 0">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-list two-line dense class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_license.index.result') }}</h3></v-subheader>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-1">fa-id-card fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">ID Permohonan</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ resultData.tradingid || "-" }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-2">fa-building fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">Nama Perniagaan</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ resultData.business_name || "-" }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-1">fa-flag fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">Status Permohonan</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ resultData.online_status || getStatus(resultData.status, resultData.workflow) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">Catatan</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ resultData.online_remark  || "-" }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-1">fa-calendar fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">Tarikh Permohonan</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ new Date(resultData.created_at).toLocaleString('en-MY') || "-" }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="caption">Tarikh Kemaskini</v-list-item-title>
                <v-list-item-subtitle class="body-2 ellipsis font-weight-bold" style="padding-bottom: 10px">{{ new Date(resultData.updated_at).toLocaleString('en-MY') || "-" }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
      </v-flex>
    </v-layout>
    <!-- Result  -->
    <v-layout justify-center v-if="listData.length > 0">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list three-line class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_license.index.result') }}</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item._id">
            <v-list-item>
              <v-list-item-action class="pl-2">
                <v-checkbox :value="item.account_reference" :input-value="data._id" @click.native="setData({ data: { _id: item.account_reference, type: item.account_type } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item.account_reference, type: item.account_type } })">
                <v-list-item-title class="body-2"><strong>{{ $t('page_license.index.license_permit_no2') }} : {{ item.info.license_no }}</strong></v-list-item-title>
                <!-- <v-list-item-subtitle><h4>{{ $t(`page_license.${item.account_type}`) | capitalize }}</h4></v-list-item-subtitle> -->
                <v-list-item-subtitle class="ellipsis"><h4>{{ $t('page_license.index.name') }} : {{ item.info.business_name !== '-' ? hideText(item.info.business_name) : hideText(item.owner_license[0].owner_name) | capitalize }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout reverse row class="pr-5">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="redirect()" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_assessment.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
  beforeRouteLeave (to, from, next) {
    this.resetData()
    next()
  },
  computed: {
    ...vuex.mapState({
      user: (state) => state.auth.data,
      data: state => state.search.data,
      form: state => state.search.form,
      error: state => state.search.error,
      listData: state => state.search.listData
    }),
    ...vuex.mapGetters({
      hasSession: 'auth/hasSession',
      hasLicenseAdminRole: 'auth/hasLicenseAdminRole'
    })
  },
  data () {
    return {
      menu1: true,
      menu2: true,
      resultData: {}
    }
  },
  created: function () {
    const { renewal } = this.$route.query
    this.$store.dispatch('auth/session')
    if (renewal && renewal === 'true') {
      this.menu2 = false
      this.menu1 = true
    }
  },
  methods: {
    ...vuex.mapActions({
      patchData: 'search/patchData',
      resetData: 'search/resetData',
      searchData: 'search/searchData',
      searchTrading: 'search/searchTrading',
      searchID: 'search/searchID',
      searchTradingWorkflow: 'search/searchTradingWorkflow'
    }),
    ...vuex.mapMutations({
      setData: 'search/setData',
      setForm: 'search/setForm'
    }),
    checkEmptyObject (obj) {
      return isEmpty(obj)
    },
    redirect () {
      return this.$router.push({
        name: 'trading-id',
        params: { id: btoa(this.data._id) },
        query: { type: 'license_trading', workflow_type: 'application' }
      })
    },
    getStatus (status, workflow) {
      if (status === 'done') {
        if (workflow && workflow.presiden && workflow.presiden.action === 'approved') return 'Permohonan Lulus'
        else return 'Permohonan Ditolak'
      }
      return 'Permohonan Sedang Dalam Proses'
    },
    searchTradingApplication: async function ($event) {
      const response = await this.searchTradingWorkflow()
      if (
        response &&
        Object.keys(response).length > 0 &&
        response.workflow_type === 'application'
      ) this.resultData = response
      else {
        this.resultData = {}
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: `Result Not Found`, visible: true})
      }
    },
    hideText (text) {
      var t = text || ''
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > Math.round(t.length * 0.25)) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    }
  }
}
</script>
